import { useState } from 'react';
import { Flex, Box, ClickableBox } from 'components/ui';
import chevronLeft from 'img/chevron-left.svg';
import chevronRight from 'img/chevron-right.svg';

interface GalleryItem {
  title: string;
  content: JSX.Element;
  description?: string;
}

interface TraitsGalleryProps {
  items: GalleryItem[],
  description?: string,
}

const TraitsGallery = ({ items }:TraitsGalleryProps) => {
  const [current, setCurrent] = useState(0);

  if (items.length === 0) {
    return null;
  }

  const currentItem = items[current];
  const prev = () => {
    const prev = current === 0 ? items.length - 1 : current - 1;
    setCurrent(prev);
  }
  const next = () => {
    const next = current === items.length - 1 ? 0 : current + 1;
    setCurrent(next);
  }
  
  return (
    <Box background="black" borderRadius="3px" width="100%" minHeight="320px" p={3}>
      <Box position="relative">
        <Box key={currentItem.title}>{ currentItem.content }</Box>
        {
          currentItem.description && (
            <Box fontStyle="italic" fontSize={['11px', '14px']} pt={2} height="90px">
              { currentItem.description }
            </Box>
          )
        }
        <Box
          position="absolute"
          bottom={currentItem.description ? '90px' : '0'}
          left="0"
          width="100%"
          p={3}
        >
          <Flex
            width="100%"
            background="rgba(0, 0, 0, .5)"
            p={2}
            justifyBetween
            alignCenter
          >
            <ClickableBox onClick={prev} mt={1}>
              <img src={chevronLeft} alt="left" width="10px" />
            </ClickableBox>
            <Box>{ currentItem.title }</Box>
            <ClickableBox onClick={next} mt={1}>
              <img src={chevronRight} alt="left" width="10px" />
            </ClickableBox>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default TraitsGallery;
